module.exports = __webpack_public_path__ + "static/media/about_thumb.03a0e4ee.jpg";